/**
 * Where a phone prompt's "Get the App" goes when the city has an app-link
 * host (`CITY.appLinkHost`, `go.london-tube.com`):
 *
 * - route prompt with both stations known → `/route?from=&to=&src=&wd=`: the
 *   installed app opens on that route; without the app nginx sends the
 *   visitor to the store through the tracking link `/go/<src>`;
 * - otherwise → `/go/<src>?wd=`: the app opens (it claims `/go/*`), or the
 *   store.
 *
 * `wd` is the visitor's Amplitude device id: when the click is matched to an
 * install, the links service sends `app_installed_from_web` under it, so the
 * A/B test counts installs per exposed visitor.
 */
export function promptAppLink({
  host,
  source,
  deviceId,
  route,
}: {
  readonly host: string
  readonly source: string
  readonly deviceId: string | undefined
  readonly route: { readonly from: string; readonly to: string } | undefined
}): string {
  const params = new URLSearchParams()
  if (route) {
    params.set('from', route.from)
    params.set('to', route.to)
    params.set('src', source)
  }
  if (deviceId) params.set('wd', deviceId)
  const query = params.toString()
  const path = route ? '/route' : `/go/${source}`
  return `https://${host}${path}${query ? `?${query}` : ''}`
}
